import React from "react";
import { usePathname } from "next/navigation";
import classNames from "classnames";

// components
import Link from "@/components/Link";

// helpers
import { removeLangFromPathname } from "@/helpers/removeLangFromPathname";

// interfaces
import { IAsideNavigationLink, IAsideNavigation } from "./IAsideNavigation";

// assets
import styles from "@/assets/styles/components/aside-navigation.module.scss";

function AsideNavigation({ navigationLinks, ...props }: IAsideNavigation) {
  const pathname = usePathname();

  const currentUrl = removeLangFromPathname(pathname);

  const renderNavigationItem = (item: IAsideNavigationLink) => {
    const itemClassName = classNames(styles["locl-aside-navigation__list-item"], {
      [styles["locl-aside-navigation__list-item_active"]]: currentUrl === item.value
    });

    return (
      <li key={`${item.value}`} className={itemClassName}>
        <Link href={item.value} className={styles["locl-aside-navigation__list-item__link"]}>
          {item.label}
        </Link>
      </li>
    );
  };

  return (
    <aside className={styles["locl-aside-navigation"]} {...props}>
      <ul className={styles["locl-aside-navigation__list"]} data-testid="locl-aside-navigation-list">
        {navigationLinks.map((item) => renderNavigationItem(item))}
      </ul>
    </aside>
  );
}

export default AsideNavigation;
